import { IRegistrationEventTabKeys, IRegistrationEventTabsName } from '../../types/competitor_types'

export const UI_REGISTER_CONST: {
  TABS: Record<IRegistrationEventTabKeys, IRegistrationEventTabsName>
} = {
  TABS: {
    TEAM: 'Start',
    REGISTER: 'Register',
    HORSES: 'Horses',
    FEES: 'Fees',
    TICKETS: 'Tickets',
    PAPERWORK: 'Roles',
    SIGN: 'Sign',
    COMMENTS: 'Comments',
    CONFIRMATION: 'Confirm and Pay',
  },
}

const EVENT_REG_CLINIC_TABS_CONST = [
  {
    tabName: UI_REGISTER_CONST.TABS.TEAM,
    icon: '/assets/og_icons/start-1.svg',
    activeIcon: '/assets/og_icons/start-2.svg',
    max_steps: 1,
  },
  {
    tabName: UI_REGISTER_CONST.TABS.REGISTER,
    activeIcon: '/assets/og_icons/Shortlist-2.svg',
    icon: '/assets/og_icons/Shortlist-1.svg',
    max_steps: 1,
  },
  {
    tabName: UI_REGISTER_CONST.TABS.HORSES,
    icon: '/assets/og_icons/YearofHorse-1.svg',
    activeIcon: '/assets/og_icons/YearofHorse-2.svg',
    max_steps: 1,
  },
  {
    tabName: UI_REGISTER_CONST.TABS.FEES,
    icon: 'assets/og_icons/Calculator-1.svg',
    activeIcon: '/assets/og_icons/Calculator-2.svg',
    max_steps: 1,
  },
  {
    tabName: UI_REGISTER_CONST.TABS.TICKETS,
    icon: 'assets/og_icons/Two Tickets-1.svg',
    activeIcon: '/assets/og_icons/Two Tickets-2.svg',
    max_steps: 1,
  },
  {
    tabName: UI_REGISTER_CONST.TABS.PAPERWORK,
    icon: '/assets/og_icons/teamClinic-1.svg',
    activeIcon: '/assets/og_icons/teamClinic-2.svg',
    max_steps: 1,
  },
  {
    tabName: UI_REGISTER_CONST.TABS.SIGN,
    icon: '/assets/cp_icons/QuillPen-1.svg',
    activeIcon: '/assets/cp_icons/Quill Pen-2.svg',
    max_steps: 1,
  },
  {
    tabName: UI_REGISTER_CONST.TABS.COMMENTS,
    icon: '/assets/og_icons/Messaging-1.svg',
    activeIcon: '/assets/og_icons/Messaging-2.svg',
    max_steps: 1,
  },
  {
    tabName: UI_REGISTER_CONST.TABS.CONFIRMATION,
    icon: '/assets/img/dark/inspection.svg',
    activeIcon: '/assets/img/color/Inspection.svg',
    max_steps: 1,
  },
]

export const MEMBER_ROLES: { [key: string]: MEMBER_ROLES_TYPE } = {
  AGENT: 'Agent',
  COACH: 'Coach',
  FRIEND: 'Friend',
  GROOM: 'Groom',
  GUARDIAN: 'Guardian',
  OWNER: 'Owner',
  RIDER: 'Rider',
  SPONSOR: 'Sponsor',
  STAFF: 'Staff',
  TRAINER: 'Trainer',
}

export type MEMBER_ROLES_TYPE =
  | 'Agent'
  | 'Coach'
  | 'Friend'
  | 'Groom'
  | 'Guardian'
  | 'Owner'
  | 'Rider'
  | 'Sponsor'
  | 'Staff'
  | 'Trainer'

export { EVENT_REG_CLINIC_TABS_CONST }
